export default __webpack_public_path__ + "static/btclassic-windows-screen-e53b087817da3efa977e2c6f9a4c52a1.jpg";